import _ from 'lodash';
import Backbone from 'backbone';
import ImageModel from '../../models/media/imageModel';
import {search} from '../../sinclair/sinclair.media.utils';

const ImageCollection = Backbone.Collection.extend({
    url: '/api/rest/facade/image',
    model: ImageModel,
    parse(data) {
        const that = this;
        if (data) {
            that.add(data.hasOwnProperty('data') ? data.data : data.assets);
        }

        return this.models;
    },
    /*
     * to set the api url from story view
     */
    setUrl(url) {
        this.url = url;
        this.model.rootUrl = url;
        this.model.url = url;
    },
    renditions: {
        large16x9Url: {
            name: 'large16x9Url',
            width: 986,
            height: 555,
            x: 0,
            y: 0,
            scaleWidth: 986,
        },
        large36x25Url: {
            name: 'large36x25Url',
            width: 360,
            height: 250,
            x: 0,
            y: 0,
            scaleWidth: 360,
        },
        large1x1Url: {
            name: 'large1x1Url',
            width: 360,
            height: 360,
            x: 0,
            y: 0,
            scaleWidth: 360,
        },
        medium16x9Url: {
            name: 'medium16x9Url',
            width: 648,
            height: 364,
            x: 0,
            y: 0,
            scaleWidth: 648,
        },
        medium36x25Url: {
            name: 'medium36x25Url',
            width: 144,
            height: 100,
            x: 0,
            y: 0,
            scaleWidth: 144,
        },
        medium1x1Url: {
            name: 'medium1x1Url',
            width: 200,
            height: 200,
            x: 0,
            y: 0,
            scaleWidth: 200,
        },
        small16x9Url: {
            name: 'small16x9Url',
            width: 160,
            height: 90,
            x: 0,
            y: 0,
            scaleWidth: 160,
        },
        small36x25Url: {
            name: 'small36x25Url',
            width: 72,
            height: 50,
            x: 0,
            y: 0,
            scaleWidth: 72,
        },
        small1x1Url: {
            name: 'small1x1Url',
            width: 90,
            height: 90,
            x: 0,
            y: 0,
            scaleWidth: 90,
        },
        large21x9Url: {name: 'large21x9Url', width: 1280, height: 548, x: 0, y: 0, scaleWidth: 986},
        medium21x9Url: {name: 'medium21x9Url', width: 640, height: 274, x: 0, y: 0, scaleWidth: 648},
        small21x9Url: {name: 'small21x9Url', width: 160, height: 68, x: 0, y: 0, scaleWidth: 210},

        large3x1Url: {name: 'large3x1Url', width: 1280, height: 426, x: 0, y: 0, scaleWidth: 986},
        medium3x1Url: {name: 'medium3x1Url', width: 640, height: 274, x: 0, y: 0, scaleWidth: 648},
        small3x1Url: {name: 'small3x1Url', width: 160, height: 53, x: 0, y: 0, scaleWidth: 270},

        large3x4Url: {name: 'large3x4Url', width: 960, height: 427, x: 0, y: 0, scaleWidth: 320},
        medium3x4Url: {name: 'medium3x4Url', width: 480, height: 640, x: 0, y: 0, scaleWidth: 144},
        small3x4Url: {name: 'small3x4Url', width: 120, height: 160, x: 0, y: 0, scaleWidth: 72},

        jumbo2x3Url: {name: 'jumbo2x3Url', width: 1280, height: 1920, x: 0, y: 0, scaleWidth: 960},
        large2x3Url: {name: 'large2x3Url', width: 854, height: 1280, x: 0, y: 0, scaleWidth: 533},
        medium2x3Url: {name: 'medium2x3Url', width: 427, height: 640, x: 0, y: 0, scaleWidth: 133},
        small2x3url: {name: 'small2x3url', width: 107, height: 160, x: 0, y: 0, scaleWidth: 60},
    },
    getRenditions() {
        return this.renditions;
    },
    updateOffset(total) {
        search.image.total = total;
        search.image.offset += this.length;
    },
    findNewImages() {
        return _.filter(this.models, function(model) {
            return model.toJSON().image.uuid === undefined || model.toJSON().image.uuid === null;
        });
    },
});
export default ImageCollection;
